import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const AltAvatar = ({ initials, size = 36, sx = {} }) => {
  const currentUser = useCurrentUser();
  const roleStyles = {
    teacher: {
      backgroundColor: "rgba(142, 51, 255, 0.16)",
      textColor: "#5119B7",
      label: "Coach",
    },
    climber: {
      backgroundColor: "rgba(7, 141, 238, 0.16)",
      textColor: "#0351AB",
      label: "Climber",
    },
    schoolstaff: {
      backgroundColor: "rgba(255, 171, 0, 0.16)",
      textColor: "#B76E00",
      label: "Staff",
    },
    districtadmin: {
      backgroundColor: "rgba(0, 184, 217, 0.16)",
      textColor: "#006C9C",
      label: "Administrator",
    },
  };
  const userRole = roleStyles[currentUser.role];
  return (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundColor: userRole?.backgroundColor,
        color: userRole?.textColor || "#000",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontSize: "inherit", fontWeight: "inherit" }}
      >
        {initials}
      </Typography>
    </Box>
  );
};

AltAvatar.propTypes = {
  initials: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  size: PropTypes.number,
  sx: PropTypes.object,
};

export default AltAvatar;
